import { dataCircleRotationSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCircleRotationSolid = /*#__PURE__*/createIcon(dataCircleRotationSolid)
export default IconCircleRotationSolid
